export default __webpack_public_path__ + "static/media/3GQ67Bwg.8a236ec1.jpg";